import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import { appSubDir } from '../../configs/app';
import './TopCategoriesMobile.scss';

const TopCategoriesMobile: React.FC = () => {
    const categories = [
        {
            title: 'Bags',
            image: 'assets/img/categories/bags.webp',
            link: appSubDir + 'categories/' + encodeURIComponent('Bags, backpacks, covers and suitcases')
        },
        {
            title: 'Shoes',
            image: 'assets/img/categories/shoes.webp',
            link: appSubDir + 'categories/' + encodeURIComponent('Footwear')
        },
        {
            title: 'Jewelry',
            image: 'assets/img/categories/jewelry.webp',
            link: appSubDir + 'categories/' + encodeURIComponent('Ornaments')
        },
        {
            title: 'Baby Items',
            image: 'assets/img/categories/baby_items.webp',
            link: appSubDir + 'categories/' + encodeURIComponent('Baby clothes')
        },
        {
            title: 'Beauty Products',
            image: 'assets/img/categories/beauty_products.webp',
            link: appSubDir + 'categories/' + encodeURIComponent('Cosmetics and skin care')
        },
        {
            title: 'Mens Clothing',
            image: 'assets/img/categories/mens_clothing.webp',
            link: appSubDir + 'categories/' + encodeURIComponent("Men's clothing")
        },
        {
            title: 'Womens Clothing',
            image: 'assets/img/categories/womens_clothing.webp',
            link: appSubDir + 'categories/' + encodeURIComponent("Women's clothing")
        },
        {
            title: 'Sunglass',
            image: 'assets/img/categories/sunglasses.webp',
            link: appSubDir + 'categories/' + encodeURIComponent('Glasses and accessories')
        },
        {
            title: 'Phone Accessories',
            image: 'assets/img/categories/phone_accessories.webp',
            link: appSubDir + 'categories/' + encodeURIComponent('Mobile electronics')
        },
        {
            title: 'Sports & Fitness',
            image: 'assets/img/categories/sports_fitness.webp',
            link: appSubDir + 'categories/' + encodeURIComponent('Sports, Tourism and Musical Instruments')
        },
        {
            title: 'Watches',
            image: 'assets/img/categories/watches.webp',
            link: appSubDir + 'categories/' + encodeURIComponent('Watch')
        },
        {
            title: 'Food Items',
            image: 'assets/img/categories/food_items.webp',
            link: appSubDir + 'categories/' + encodeURIComponent('Food, Drinks')
        },
        {
            title: 'Traveling',
            image: 'assets/img/categories/traveling.webp',
            link: appSubDir + 'categories/' + encodeURIComponent('Travel Bags & Cases')
        },
        {
            title: 'Gadgets',
            image: 'assets/img/categories/gadgets.webp',
            link: appSubDir + 'categories/' + encodeURIComponent('Electronics Devices')
        }
    ];

    return (
        <div className="top-categories-mobile-container">
            <h2 className="section-title">Top Categories</h2>
            <div className="carousel-wrapper">
                <Swiper
                    slidesPerView={3}
                    spaceBetween={12}
                    navigation={true}
                    modules={[Navigation]}
                    className="categories-swiper"
                    breakpoints={{
                        480: {
                            slidesPerView: 4,
                            spaceBetween: 12
                        },
                        768: {
                            slidesPerView: 6,
                            spaceBetween: 16
                        },
                        1024: {
                            slidesPerView: 8,
                            spaceBetween: 16
                        },
                        1200: {
                            slidesPerView: 9,
                            spaceBetween: 20
                        }
                    }}
                >
                    {categories.map((cat, index) => (
                        <SwiperSlide key={index}>
                            <Link to={cat.link} className="category-card">
                                <div className="image-wrapper">
                                    <img src={cat.image} alt={cat.title} loading="lazy" />
                                </div>
                                <span className="category-title">{cat.title}</span>
                            </Link>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default TopCategoriesMobile;
